var __rspack_ns_object = {"rE":"7.9.37"}